<template>
  <div class="root" v-title :data-title="t('page.downloadTitle')">
    <div class="content">
      <component :is="Template000"></component>
    </div>
    <div class="float_button">
      <component :is="CommonDownloadButton"></component>
    </div>
    <p class="company-footer">{{ t('page.companyName') }}</p>
  </div>
</template>

<script lang="ts" setup>
import CommonDownloadButton from '../components/CommonDownloadButton.vue';
import Template000 from '../components/template/Template-000.vue';
import AppLinkStat from '../stats/AppLinkStat';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import PageParamsUtil from '../../utils/PageParamsUtil';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

// document.addEventListener(
//   'touchstart',
//   function (event) {
//     if (event.touches.length > 1) {
//       event.preventDefault();
//     }
//   },
//   {
//     capture: false,
//     passive: false,
//   },
// );
onMounted(() => {
  AppLinkStat.eventAbilityPageShow(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    PageParamsUtil.getPageUrl(),
  );
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.root {
  position: relative;
  width: 100%;
  height: 100%;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
}

.float_button {
  position: fixed;
  width: 100%;
  height: 100%;
}

.company-footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  margin: 0;
  padding: 8px 16px;
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: rgb(13 13 13 / 40%);
  line-height: 16px;
  pointer-events: none;
}
</style>
